import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { adminRightUser } from '../../../components/_utils/appUtils'
import { Popconfirm, Tooltip } from 'antd'
import { AllowComponentRightsWise } from '../../WebComponent/allowComponentRightsWise'
import { reOpenCyprusApplicationsFxn } from '../actions/chooseStudent'

const CyprusReOpenApplication = (props) => {
  let { record, reloadFxn } = props
  let dispatch = useDispatch()
  const events = {
    reOpenApplication: async () => {
      let { _id: studentId, applications } = record
      let obj = {
        studentId,
        applicationId: applications._id
      }
      let resp = await dispatch(reOpenCyprusApplicationsFxn(obj))
      if (resp && resp.success) {
        reloadFxn()
      }
    }
  }

  return (
    <AllowComponentRightsWise rightUserType={[...adminRightUser, 'branchManager', 'branchUser']}>
      {record.applications && record.applications.isCaseCancelled && <Popconfirm
        title={'Are you sure, you want to re-activate application?'}
        okText={'Yes'}
        cancelText={'No'}
        onConfirm={() => {
          events.reOpenApplication(record._id)
        }}>
        <Tooltip title={'Re-Active Cancelled App.'}>
          <a className={'btn'}>
            <img src={'/assets/re-active.png'} alt='' />
          </a>
        </Tooltip>
      </Popconfirm>
      }
    </AllowComponentRightsWise>
  )
}
export default CyprusReOpenApplication
